import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TemplateService } from '../../../../../@core/services/template.service';
import { DataService } from '../../../../../data/services/data.service';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
// import { ConfigurableOperationDefinition } from '../../../../../generated/generated-types';
// import { PromotionService } from '../../../services/promotion.service';

@Component({
  selector: 'app-promotion-condition-dropdown',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PromotionConditionDropdownComponent extends GenericBaseModelDropDown<any> {

  // allConditions: ConfigurableOperationDefinition[] = [];
  allConditions = [];

  constructor(
    // private service: PromotionService,
    private dataService: DataService,
    private templateService: TemplateService) {
    super(null, null);
    // this.offlineMode = true;
  }
}